app.controller('teacherGroupDetailsCtrl', [
    '$scope', '$rootScope', '$http', '$state', '$stateParams', 'mdContentService', function ($scope, $rootScope, $http, $state, $stateParams, mdContentService) {
    	var vm = this;

    	vm.loaded = false;
    	vm.game = {}
        vm.gameIndex = 0;

        vm.members = new Array(6);
        for (var i = 0; i < vm.members.length; i++) {
            vm.members[i] = "";
        }

        vm.exercises = [];

    	$http.get('/api/gameday/games').then(function(response) {
            var games = response.data.games;
            var game;
            var gameIndex = 0;
            for (var i = 0; i < games.length; i++) {
                var iterGame = games[i];
                if (iterGame.key == $stateParams.id) {
                    game = iterGame;
                    gameIndex = i;
                    break;
                }
            }
            if (!game) {
                return;
            }

    		vm.game = game;
            vm.gameIndex = gameIndex;

            for (var i = 0; i < Math.min(vm.game.teamMembers.length, 6); i++) {
                vm.members[i] = vm.game.teamMembers[i];
            }

            vm.exercises = angular.copy(vm.game.exercises);

            vm.loaded = true;

            mdContentService.triggerSyntheticScrollEvent();
    	});

        vm.sanitizedMembers = function() {
            var newMembers = [];

            for (var i = 0; i < vm.members.length; i++) {
                var member = vm.members[i];
                var trimmedMember = member.trim();
                if (trimmedMember.length === 0) {
                    continue;
                }
                newMembers.push(trimmedMember);
            }

            return newMembers;
        }

    	vm.save = function(evt, done) {
            evt.preventDefault();
 
            var game = angular.copy(vm.game);
            game.teamMembers = vm.sanitizedMembers();
            game.exercises = vm.exercises;

    		$http.put('/api/gameday/game/' + $stateParams.id, game).then(function(response) {
                if (done === undefined) {
        			 $state.reload();
                } else {
                     $state.go('teacher.setupgroups');
                }
    		});
    	}

        vm.done = function(evt) {
            vm.save(evt, true);
        }
    }
]);